import React from 'react'

const splitOnLineBreak = (text) => {
  if (!text.includes('\n')) return <p>{text}</p>

  // eslint-disable-next-line react/no-array-index-key
  return text.split('\n').map((textPiece, index) => <p key={index}>{textPiece}</p>)
}

export { splitOnLineBreak }
